<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationPage_01"><p class="dedicationText"><span><em class="italic"><span>For Hilary Hale<br/>
Whose loyalty, encouragement and editorial gift<br/>
have taken Alex Cooper around the world</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743299084_dedicationPage_01.vue?2ba378ec